import React, { Component, useEffect, useState } from "react";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { useParams } from "react-router-dom";

const images = [
  {
    original: "assets/images/ring/1.jpg",
    thumbnail: "assets/images/ring/1.jpg",
  },
  {
    original: "assets/images/ring/2.jpg",
    thumbnail: "assets/images/ring/2.jpg",
  },
  {
    original: "assets/images/ring/4.jpg",
    thumbnail: "assets/images/ring/4.jpg",
  },
];

function Catelogue() {
  const { ledgerID, catalogueID } = useParams();
  console.log(ledgerID, catalogueID);

  const [designData, setDesignData] = useState([]);
  const [selecteddata, setselecteddata] = useState("");
  const [assignID, setassignID] = useState("");
  const [remarks, setremarks] = useState("");
  const [sellerData, setSellerData] = useState([]);
  const [name, setname] = useState("");
  const [mobile, setmobile] = useState("");
  const [logo, setlogo] = useState("");

  useEffect(() => {
    getData();
    fetchSellerDetails();
  }, []);

  const getData = async () => {
    const url =
      "https://appsapi.dialerp.com/api/Dynamic/GetRecords?AppVersion=1.44&appName=SavyaBuyer&erpIDprm=90&parentIDprm=40011&=null";

    const requestBody = {
      viewFormat: "columnname",
      useAtlusSearch: "false",
      tabErpID: "2754",
      pgSize: "1000",
      index: "1",
      filters: JSON.stringify({
        LedgerID: parseInt(ledgerID),
        CatalogueID: parseInt(catalogueID),
      }),
    };

    const res = await fetchApi(url, requestBody);

    // store designID -> assignID mapping
    const assignMap = {};
    res?.response?.records?.forEach((item) => {
      if (item?.DesignID && item?.AssignID) {
        assignMap[item.DesignID] = item.AssignID;
      }
    });

    const designIds = Object.keys(assignMap)
      .map((id) => parseInt(id))
      .filter(Boolean);

    if (designIds?.length > 0) {
      getCatalogueData(designIds, assignMap);
    }
  };

  const getCatalogueData = async (designIds, assignMap) => {
    const url =
      "https://appsapi.dialerp.com/api/Dynamic/GetRecords?AppVersion=1.44&appName=SavyaBuyer&erpIDprm=90&parentIDprm=40011&=null";

    const requestBody = {
      viewFormat: "columnname",
      useAtlusSearch: "false",
      tabErpID: "1289",
      pgSize: "1000",
      index: "1",
      filters: JSON.stringify({
        DesignID: { $in: designIds },
      }),
    };

    const res = await fetchApi(url, requestBody);

    // merge AssignID from first API into second response
    const mergedData = (res?.response?.records || []).map((item) => {
      return {
        ...item,
        AssignID: assignMap[item.DesignID] || null,
      };
    });

    console.log("meregd data", mergedData);

    setDesignData(mergedData);
  };

  const fetchApi = async (url, body) => {
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Authorization-Token":
            "bZYpOc2Fo/WkOvIEt0LANElncp9tt3NeKTzB0MyIm+CUbGf0rb2l/Z4m684rQCUrDT/T/x7e47oBYOKW44sl/MfQmSgsnccmHq9KLkQBvqAC4JrU2ZwufvbtTPbFkldEFZbX6l92aW/lV2VQ5KyVp7/8WCywxHezmjmcnfuL3wDzw6XfF5j1fbJJEAnIzIpbiGtYChWE3h4Ee0qG2TIZb1eBAesKy+7Ae/ppsbQfpzF0nJqTcTdYajlKGIrmjVzEpe1ZcB56Ht7pJjxYCda4smL5VDeeTFTO+qGHuPtS0sDdaCrn63G2lzxs1jLcBQnBPJtEJTphl7Aj4Tlre9P/qt2Xsx6GOJGDiZmP+ElDTtyOAZVx9U6H6ndrxcP2XxAaCHlGxgp8rpOLF7ZSJILSwRnl39hx//qMSztZzCeTW6/mgng5pmaL/gypxftDgvlq",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("API call failed:", error);
      return null;
    }
  };

  const fetchSellerDetails = async (designIds) => {
    const url =
      "https://dialerpwebapis-dev-as.azurewebsites.net/api/Dynamic/GetRecords?tabErpID=526&tabName=All%20Ledgers&appname=web&tmpUId=40011&tmpPId=40011";

    const requestBody = {
      pgSize: 100,
      viewFormat: "columnname",
      filterButtons: "",
      index: 1,
      toEmailID: "amit99nkc@gmail.com",
      tabErpID: 526,
      useAtlusSearch: true,
      RoleID: 0,
      LedgerID: 0,
      order: -1,
      processID: 1,
      filters: `{'LedgerID':${ledgerID}}`,
    };

    const res = await fetchApi(url, requestBody);
    setSellerData(res?.response?.records || []);
    fetchSellerlogo(res?.response?.records[0]?.LoginMobile);

    console.log("sellerdata", res?.response);
  };

  const fetchSellerlogo = async (mobile) => {
    const url =
      "https://dialerpwebapis-dev-as.azurewebsites.net/api/Dynamic/GetRecords?tabErpID=1429&tabName=Users&appname=web&tmpUId=40011&tmpPId=40011";

    const requestBody = {
      pgSize: 100,
      viewFormat: "columnname",
      filterButtons: "",
      index: 1,
      toEmailID: "amit99nkc@gmail.com",
      tabErpID: 1429,
      useAtlusSearch: true,
      RoleID: 0,
      LedgerID: 0,
      order: -1,
      processID: 1,
      filters: `{'LoginMobile':${mobile}}`,
    };

    const res = await fetchApi(url, requestBody);
    setlogo(res?.response?.records[0]?.ProfilePic);

    console.log("sellerlogo data", res?.response);
  };

  const imagesfilter = (imageString) => {
    if (!imageString) return []; // handle undefined/null cases

    return imageString.split(",").map((url) => ({
      original: url.trim(),
      thumbnail: url.trim(),
    }));
  };

  const extractValue = (str, key) => {
    const regex = new RegExp(`${key}~\\^\\w\\s*:\\s*([^,@]+)`);
    const match = str.match(regex);
    return match ? match[1].trim() : "N/A";
  };

  const parseDescription = (description) => {
    const sections = description?.split("@");
    const data = {};

    sections.forEach((section) => {
      const [sectionTitle, sectionContent] = section.split("#");

      const keyValues = sectionContent?.split(",").reduce((acc, item) => {
        const [keyPart, value] = item.split(":");
        if (!keyPart || !value) return acc;

        // Clean key: remove ~^X part
        const cleanKey = keyPart?.split("~")[0].trim();
        acc[cleanKey] = value?.trim();
        return acc;
      }, {});

      data[sectionTitle.trim()] = keyValues;
    });

    return data;
  };

  const submitquery = async() => {
    console.log("query", selecteddata, name, mobile, remarks);


    const url =
    "https://dialerpwebapis-dev-as.azurewebsites.net/api/Dynamic/AddUpdateRecords?tabErpID=2756&tabName=Catalogue%20Enquiry&buttonFilter=&appname=web&tmpUId=40011&tmpPId=40011";

  const requestBody =[
    {
        "CustMobile": mobile,
        "CustName": name,
        "CustRemarks": remarks,
        "AssignID": assignID,
       
    }
]
  const res = await fetchApi(url, requestBody);

  console.log("res query", res)
  if(res?.hasErrors == false){
    setname("")
    setmobile("")
    setselecteddata("")
    setremarks("")
    setassignID("")
    alert("Query submitted successfully")
  }



  };

  return (
    <>
      <div className="catelogue">
        <section>
          <div
            class="modal fade"
            id="exampleModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">
                    Product Query
                  </h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div className="row forrm">
                    <div class="col-md-12">
                      <label>Select Product</label>
                      <input
                        type="text"
                        className="form-control"
                        value={selecteddata}
                        placeholder="CZ Ladies Ring"
                        disabled
                        readOnly
                      />
                    </div>

                    <div className="col-md-12">
                      <label>
                        Name<span>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter your name"
                        onChange={(e) => setname(e.target.value)}
                      />
                    </div>
                    <div className="col-md-12">
                      <label>
                        Mobile Number<span>*</span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="9999999999"
                        maxLength="10"
                        value={mobile} // ✅ tie input to state
                        onChange={(e) => {
                          const value = e.target.value.replace(/\D/g, ""); // remove non-digits
                          if (value.length <= 10) {
                            setmobile(value);
                          }
                        }}
                      />
                    </div>
                    <div className="col-md-12">
                      <label>
                        Tell us about your query<span></span>
                      </label>
                      <textarea
                        className="form-control"
                        onChange={(e) => setremarks(e.target.value)}
                        rows="3"
                        placeholder="Mention your query here"
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    onClick={() => {
                      submitquery();
                    }}
                    type="button"
                    disabled={!name || mobile.length !== 10}
                    class="btn btn-primary"
                     data-dismiss="modal"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <h1>Rings to cherish forever</h1>

            <img src="../../assets/images/border.svg" alt="" />
          </div>
          <div className="headcomp">
            <div className="row">
              <div className="col-md-3">
                <div className="loggo">
                  <img src={logo} alt="" />
                </div>
              </div>
              <div className="col-md-9">
                <div className="companydetails">
                  <strong>
                    {sellerData[0]?.LedgerName} ({sellerData[0]?.LedgerGroup}){" "}
                  </strong>
                  <p>+91-{sellerData[0]?.LoginMobile}</p>
                  <p>{sellerData[0]?.LoginEmail}</p>
                  <div className="border"></div>
                  <p>{sellerData[0]?.Address}</p>
                </div>
              </div>
            </div>
          </div>

          {designData?.map((data, i) => {
            const descObject = parseDescription(data?.TechnicalDescription);
            return (
              <div
                onClick={() => {
                  setselecteddata(data?.DesignName);
                  setassignID(data?.AssignID);
                }}
                className="imagedetails"
              >
                <div className="row no-gutters">
                  <div className="col-lg-4 col-md-12">
                    <ImageGallery
                      items={imagesfilter(data?.DesignPic)}
                      // thumbnailPosition={"right"}
                      showNav="false"
                      showPlayButton="false"
                    />
                  </div>
                  <div className="col-lg-8 col-md-12">
                    <div className="rightblockk">
                      <div className="titles">
                        <b>{data?.DesignName}</b>
                      </div>
                      <div className="row no-gutters">
                        <div className="col-md-4 col-md-4">
                          <div className="descriptionlist">
                            <h3>Product Details</h3>
                            <ul>
                              {Object.entries(
                                descObject["Product Details"] || {}
                              ).map(([key, value]) => (
                                <li key={key}>
                                  <span>{key}</span> <small>:</small>{" "}
                                  <span>{value}</span>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="descriptionlist">
                            <h3>Gold Details</h3>
                            <ul>
                              {Object.entries(
                                descObject["Gold Details (CZ)"] || {}
                              ).map(([key, value]) => (
                                <li key={key}>
                                  <span>{key}</span> <small>:</small>{" "}
                                  <span>{value}</span>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="descriptionlist">
                            <h3>CZ Details</h3>
                            <ul>
                              {Object.entries(
                                descObject["CZ Details"] || {}
                              ).map(([key, value]) => (
                                <li key={key}>
                                  <span>{key}</span> <small>:</small>{" "}
                                  <span>{value}</span>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div className="bottombarr">
                        <div className="row">
                          <div className="col-md-8">
                            <div className="crumb">
                              <p>
                                <span>Gold Jewellery</span>/
                                <span>Gold Ring</span>/
                                <span className="blue">{data?.DesignName}</span>
                              </p>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <button
                              className="btn btn-theme btnborder"
                              data-toggle="modal"
                              data-target="#exampleModal"
                            >
                              Generate Query
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </section>
      </div>
    </>
  );
}

export default Catelogue;
